<template>
  <div class="wrap">
    <header class="header header--step">
      <div class="header__container">
        <div class="header__row">
          <!-- 20230922 hotfix : 첫번째 화면에서 이전버튼 숨김처리-->
          <button @click="swiperSlidePrev()" type="button" class="prev" :class="{'first-index-prev-off' : this.swiperIndex == 1 }" aria-lebel="이전"></button>
          <button @click="moveMainHome()" type="button" class="close" aria-label="닫기"></button>
        </div>
        <nav class="step">
          <ol class="step__row">

            <!-- Swiper Index 1  ~ 8 -->
            <li class="step__step" :aria-current="this.swiperIndex <= 8 ? 'step' : null">
              <span>1</span>
              <p>알쏭달쏭 단백질 퀴즈</p>
            </li>

            <!-- Swiper Index 9 -->
            <li class="step__step" :aria-current="this.swiperIndex === 9 ? 'step' : null" >
              <span>2</span>
              <p>단백질 부족 자가진단</p>
            </li>

            <!-- Swiper Index 10 ~ 11 -->
            <li  class="step__step" :aria-current="this.swiperIndex === 10 || this.swiperIndex === 11  ? 'step' : null" >
              <span>3</span>
              <p>하루 권장 섭취량 체크</p>
            </li>

          </ol>
        </nav>
        <div class="progress-bar">
          <div class="progress-bar__row">

            <!--알쏭달쏭 단백질 퀴즈-->
            <div class="progress-bar__bar">
              <div :style="{width: stepOneProgressBarWidth }"></div>
            </div>
            <!--알쏭달쏭 단백질 퀴즈 END -->

            <!-- 단백질 자가진단 -->
            <div class="progress-bar__bar">
              <div :style="{width : stepTwoProgressBarWidth  }"></div>
            </div>
            <!-- 단백질 자가진단 END  -->

            <!-- 단백질 섭취목적 확인 -->
            <div class="progress-bar__bar">
              <div :style="{width : stepThrProgressBarWidth  }"></div>
            </div>
            <!-- 단백질 섭취목적 확인 END -->

          </div>
        </div>
      </div>
    </header>

    <div class="contents">
      <div class="protein-check">
        <div class="protein-check__swiper">
          <!-- 230918 수정 -->
          <div class="swiper-container">
          <!-- 230918 수정 -->
            <div class="swiper-wrapper">
              <!-- 1번문제 -->
              <swiper :options="swiperOption" ref="mySwiper">
                <swiper-slide>
                  <div class="swiper-slide" data-index-number="1">
                    <div class="quiz">
                      <span class="quiz__chapter">
                        <span>Q1</span>
                      </span>
                      <p class="quiz__question">
                        단백질은 운동하는 사람에게만<br>
                        중요한 영양소이다?
                      </p>
                      <div class="quiz__answer quiz__answer--ox">
                        <input @change="moveSwiperSlide()" v-model="myproteinQuiz.Q1" value="O" type="radio"
                               id="question01_01" name="question01">
                        <label for="question01_01" aria-label="O"></label>
                        <input @change="moveSwiperSlide()" v-model="myproteinQuiz.Q1" value="X" type="radio"
                               id="question01_02" name="question01">
                        <label for="question01_02" aria-label="X"></label>
                      </div>
                    </div>
                  </div>
                </swiper-slide>

                <swiper-slide>
                  <div class="swiper-slide" data-index-number="2">
                    <div class="quiz">
                      <span class="quiz__chapter">
                        <span>Q2</span>
                      </span>
                      <p class="quiz__question">
                        단백질,<br>
                        한번에 많이 먹을수록 좋다?
                      </p>
                      <div class="quiz__answer quiz__answer--ox">
                        <input @change="moveSwiperSlide()" v-model="myproteinQuiz.Q2" type="radio" value="O"
                               id="question02_01" name="question02">
                        <label for="question02_01" aria-label="O"></label>
                        <input @change="moveSwiperSlide()" v-model="myproteinQuiz.Q2" type="radio" value="X"
                               id="question02_02" name="question02">
                        <label for="question02_02" aria-label="X"></label>
                      </div>
                    </div>
                  </div>
                </swiper-slide>

                <swiper-slide>
                  <div class="swiper-slide" data-index-number="3">
                    <div class="quiz">
                      <span class="quiz__chapter">
                        <span>Q3</span>
                      </span>
                      <p class="quiz__question">
                        나이가 들수록 체내 단백질이<br>
                        자연스럽게 줄어든다?
                      </p>
                      <div class="quiz__answer quiz__answer--ox">
                        <input @change="moveSwiperSlide()" v-model="myproteinQuiz.Q3" type="radio" value="O"
                               id="question03_01" name="question03">
                        <label for="question03_01" aria-label="O"></label>
                        <input @change="moveSwiperSlide()" v-model="myproteinQuiz.Q3" type="radio" value="X"
                               id="question03_02" name="question03">
                        <label for="question03_02" aria-label="X"></label>
                      </div>
                    </div>
                  </div>
                </swiper-slide>

                <swiper-slide>
                  <div class="swiper-slide" data-index-number="4">
                    <div class="quiz">
                      <span class="quiz__chapter">
                        <span>Q4</span>
                      </span>
                      <p class="quiz__question">
                        운동만 열심히 하면<br>
                        근육이 늘어난다?
                      </p>
                      <div class="quiz__answer quiz__answer--ox">
                        <input @change="moveSwiperSlide()" v-model="myproteinQuiz.Q4" type="radio" value="O"
                               id="question04_01" name="question04">
                        <label for="question04_01" aria-label="O"></label>
                        <input @change="moveSwiperSlide()" v-model="myproteinQuiz.Q4" type="radio" value="X"
                               id="question04_02" name="question04">
                        <label for="question04_02" aria-label="X"></label>
                      </div>
                    </div>
                  </div>
                </swiper-slide>

                <swiper-slide>
                  <div class="swiper-slide" data-index-number="5">
                    <div class="quiz">
                      <span class="quiz__chapter">
                        <span>Q5</span>
                      </span>
                      <p class="quiz__question">
                        다음 중 ‘좋은 단백질 제품을<br>
                        고르는 기준’으로 맞는 내용을<br>
                        <span class="line-highlight">모두</span> 골라주세요.
                        <em>(중복 선택)</em>
                      </p>
                      <div class="quiz__answer">
                        <input @change="nextQuestion()" v-model="myproteinQuiz.Q5" value="1" type="checkbox"
                               id="question05_01">
                        <label for="question05_01">식약처 인증 건강기능식품 제품을 선택한다.</label>
                        <input @change="nextQuestion()" v-model="myproteinQuiz.Q5" value="2" type="checkbox"
                               id="question05_02">
                        <label for="question05_02">품질 유지와 맛있는 맛을 위해 첨가물이 많은 제품을 선택한다.</label>
                        <input @change="nextQuestion()" v-model="myproteinQuiz.Q5" value="3" type="checkbox"
                               id="question05_03">
                        <label for="question05_03">아미노산 스코어가 100 이상인 높은 영양가 제품을 선택한다.</label>
                        <input @change="nextQuestion()" v-model="myproteinQuiz.Q5" value="4" type="checkbox"
                               id="question05_04">
                        <label for="question05_04">철저한 원재료 구분 유통 관리로 검증 된 원재료를 사용한 제품을 선택한다.</label>
                      </div>
                    </div>
                  </div>
                </swiper-slide>

                <swiper-slide>
                  <div class="swiper-slide" data-index-number="6">
                    <div class="quiz">
                      <span class="quiz__chapter">
                        <span>Q6</span>
                      </span>
                      <em class="quiz__noti">빈칸에 들어갈 숫자는 무엇일까요?</em>
                      <p class="quiz__question">
                        우리 몸에 반드시 필요한<br>
                        필수 및 비필수 아미노산은<br>
                        총 ____ 종이다.
                      </p>
                      <div class="quiz__answer quiz__answer">
                        <input @change="moveSwiperSlide()" v-model="myproteinQuiz.Q6" value="1" type="radio"
                               id="question06_01" name="question06">
                        <label for="question06_01">5종</label>
                        <input @change="moveSwiperSlide()" v-model="myproteinQuiz.Q6" value="2" type="radio"
                               id="question06_02" name="question06">
                        <label for="question06_02">10종</label>
                        <input @change="moveSwiperSlide()" v-model="myproteinQuiz.Q6" value="3" type="radio"
                               id="question06_03" name="question06">
                        <label for="question06_03">20종</label>
                        <!-- <label for="question06_03">2시간</label> -->

                      </div>
                    </div>
                  </div>
                </swiper-slide>

                <swiper-slide>
                  <div class="swiper-slide" data-index-number="7">
                    <div class="quiz">
                      <span class="quiz__chapter">
                        <span>Q7</span>
                      </span>
                      <em class="quiz__noti">빈칸에 들어갈 숫자는 무엇일까요?</em>
                      <p class="quiz__question">
                        단백질 섭취 골든타임은<br>
                        운동 직후 ____ 이내이다.
                      </p>
                      <div class="quiz__answer quiz__answer">
                        <input @change="moveSwiperSlide()" v-model="myproteinQuiz.Q7" value="1" type="radio"
                               id="question07_01" name="question07">
                        <label for="question07_01">10분</label>
                        <input @change="moveSwiperSlide()" v-model="myproteinQuiz.Q7" value="2" type="radio"
                               id="question07_02" name="question07">
                        <label for="question07_02">45분</label>
                        <input @change="moveSwiperSlide()" v-model="myproteinQuiz.Q7" value="3" type="radio"
                               id="question07_03" name="question07">
                        <label for="question07_03">2시간</label>
                      </div>
                    </div>
                  </div>
                </swiper-slide>

                <swiper-slide>
                  <div class="swiper-slide" data-index-number="8">
                    <div class="quiz">
                      <span class="quiz__chapter">
                        <span>Q8</span>
                      </span>
                      <p class="quiz__question">
                        다음 중 단백질의 공식 기능이<br>
                        <span class="line-highlight">아닌 것</span>은 무엇일까요?
                      </p>
                      <div class="quiz__answer quiz__answer">
                        <input @change="moveSwiperSlide()" v-model="myproteinQuiz.Q8" value="1" type="radio"
                               id="question08_01" name="question08">
                        <label for="question08_01">근육, 결합조직 등 신체 조직의 구성 성분</label>
                        <input @change="moveSwiperSlide()" v-model="myproteinQuiz.Q8" value="2" type="radio"
                               id="question08_02" name="question08">
                        <label for="question08_02">효소, 호르몬, 항체의 구성에 필요</label>
                        <input @change="moveSwiperSlide()" v-model="myproteinQuiz.Q8" value="3" type="radio"
                               id="question08_03" name="question08">
                        <label for="question08_03">체내 필수 영양성분이나 활성물질의 운반과 저장에 필요</label>
                        <input @change="moveSwiperSlide()" v-model="myproteinQuiz.Q8" value="4" type="radio"
                               id="question08_04" name="question08">
                        <label for="question08_04">시력 개선에 도움</label>
                        <input @change="moveSwiperSlide()" v-model="myproteinQuiz.Q8" value="5" type="radio"
                               id="question08_05" name="question08">
                        <label for="question08_05">체액, 산-염기의 균형 유지에 필요</label>
                        <input @change="moveSwiperSlide()" v-model="myproteinQuiz.Q8" value="6" type="radio"
                               id="question08_06" name="question08">
                        <label for="question08_06">에너지, 포도당, 지질의 합성에 필요</label>
                      </div>
                    </div>
                  </div>
                </swiper-slide>

                <!-- Step2 단백질 자가진단 시작 -->
                <swiper-slide>
                  <div class="swiper-slide" data-index-number="1">
                    <div class="quiz">
                      <p class="quiz__noti quiz__noti--secondary">
                        <span>혹시나도?</span>
                        <span class="line-highlight">스스로 알아보는 단백질 부족신호</span>
                      </p>
                      <p class="quiz__question">
                        해당되는 항목이 있는지 체크해보세요.
                        <em>(중복 선택)</em>
                      </p>
                      <div class="quiz__answer quiz__answer">
                        <input @change="nextQuestion()" v-model="myproteinSelfCheck.Q9" value="Q9-1" type="checkbox"
                               id="question09_01">
                        <label for="question09_01">머리카락이 많이 빠져 탈모가 걱정 된다.</label>
                        <input @change="nextQuestion()" v-model="myproteinSelfCheck.Q9" value="Q9-2" type="checkbox"
                               id="question09_02">
                        <label for="question09_02">머리카락이 가늘어지거나 갈라지며 푸석푸석하다.</label>
                        <input @change="nextQuestion()" v-model="myproteinSelfCheck.Q9" value="Q9-3" type="checkbox"
                               id="question09_03">
                        <label for="question09_03">피부가 거칠어지고 탄력을 잃고 주름이 생기는 것 같다.</label>
                        <input @change="nextQuestion()" v-model="myproteinSelfCheck.Q9" value="Q9-4" type="checkbox"
                               id="question09_04">
                        <label for="question09_04">손톱 발톱이 얇아지고 쉽게 갈라지거나 부러진다.</label>
                        <input @change="nextQuestion()" v-model="myproteinSelfCheck.Q9" value="Q9-5" type="checkbox"
                               id="question09_05">
                        <label for="question09_05">운동을 해도 근육이 잘 생기지 않고 전체적으로 근육량이 줄어든 느낌이 든다.</label>
                        <input @change="nextQuestion()" v-model="myproteinSelfCheck.Q9" value="Q9-6" type="checkbox"
                               id="question09_06">
                        <label for="question09_06">면역력이 약해져 감기에 자주 걸리고 잘 낫지 않는다.</label>
                        <input @change="nextQuestion()" v-model="myproteinSelfCheck.Q9" value="Q9-7" type="checkbox"
                               id="question09_07">
                        <label for="question09_07">혈액순환이 잘 되지 않아 손발이 차고 종아리나 발이 자주 붓는다.</label>
                        <input @change="nextQuestion()" v-model="myproteinSelfCheck.Q9" value="Q9-8" type="checkbox"
                               id="question09_08">
                        <label for="question09_08">단 음식이 자주 먹고싶다.</label>
                        <input @change="nextQuestion()" v-model="myproteinSelfCheck.Q9" value="Q9-9" type="checkbox"
                               id="question09_09">
                        <label for="question09_09">항상 피곤하고 잔병치레가 많다.</label>
                        <input @change="nextQuestion()" v-model="myproteinSelfCheck.Q9" value="Q9-10" type="checkbox"
                               id="question09_10">
                        <label for="question09_10">예전과 달리 무거운 것을 들기 힘들고 근력이 떨어진 것 같다.</label>
                      </div>
                      <p class="quiz__etc">*출처 : Indian J Nutr Dietetics 57.4 (2020): 486-497., J. Food Sci. Nutr 1
                        (2017): 645-647., Paediatrics and international child health 35.2 (2015): 83-89., Obesity
                        reviews 6.2 (2005): 133-142. Seshadri, Divya, and Dipankar De. “Nails in nutritional
                        deficiencies.” Indian Journal of Dermatology, Venereology and Leprology 78 (2012): 237.</p>
                    </div>
                  </div>
                </swiper-slide>

                <!-- Step 3-->
                <swiper-slide>
                  <div class="swiper-slide" data-index-number="1">
                    <div class="quiz">
                      <span class="quiz__chapter">
                        <span>Q1</span>
                      </span>
                      <p class="quiz__question">
                        단백질을 섭취하는 목적을<br>
                        알려주세요.
                      </p>
                      <div class="quiz__answer quiz__answer">
                        <input @change="moveSwiperSlide()" v-model="myproteinPurpose.Q10" value="Q10-1" type="radio"
                               id="question10_01" name="question10">
                        <label for="question10_01">
                          건강을 위해 필수 영양소인<br>
                          단백질을 섭취하려고 해요.
                        </label>
                        <input @change="moveSwiperSlide()" v-model="myproteinPurpose.Q10" value="Q10-2" type="radio"
                               id="question10_02" name="question10">
                        <label for="question10_02">
                          탄탄한 몸을 위해<br>
                          체지방 조절을 하고 싶어요.
                        </label>
                        <input @change="moveSwiperSlide()" v-model="myproteinPurpose.Q10" value="Q10-3" type="radio"
                               id="question10_03" name="question10">
                        <label for="question10_03">근육 증가를 원해요.</label>
                      </div>
                    </div>
                  </div>
                </swiper-slide>

                <!-- Step 3 -->
                <swiper-slide>
                  <div class="swiper-slide" data-index-number="2">
                    <div class="quiz">
                      <span class="quiz__chapter">
                        <span>Q2</span>
                      </span>
                      <p class="quiz__question">몸무게를 알려주세요.</p>
                      <div class="quiz__answer">
                        <div class="quiz__form">
                          <label for="weight" class="a11y">몸무게 </label>
                          <input v-model="weight" type="number" id="weight" maxlength="5" placeholder="00">
                          <span>kg</span>
                        </div>
                        <p class="quiz__etc">*단백질 하루 권장 섭취량 계산에 필요합니다.</p>
                      </div>
                      <div class="button">
                        <div class="button__row">
                          <input id="resultButton"
                                 type="submit"
                                 class="button__item button__item--secondary"
                                 value="결과보기"
                                 :disabled="this.weight <= 0"
                                 @click="myproteinResult()"
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </swiper-slide>
              </swiper>
            </div>
          </div>
        </div>

        <div :style=" {display : this.nextSwiperButton ? 'flex' : 'none'}" class="protein-check__next button">
          <div class="button__row">
            <button @click="nextButtonClose()" type="button" class="button__item">
              다음
              <i></i>
            </button>
          </div>
        </div>

      </div>
      <!-- end of class="protein-check" -->
    </div>

  </div>
</template>

<script>

import {Swiper, SwiperSlide} from 'vue-awesome-swiper'
// import 'swiper/css/swiper.css'
// SET_PROTEIN_QUIZ
import {MYPROTEIN, SET_PROTEIN_QUIZ, SET_PROTEIN_SELF_CHECK, SET_PROTEIN_PURPOSE} from '@/store/actions/myprotein'

import axios from 'axios'

export default {
  name: 'myprotein-quiz',
  components: {
    Swiper,
    SwiperSlide
  },
  data () {
    return {
      swiperIndex: 1, // Swiper Index,
      nextSwiperButton: false, //  중복선택 문제 버튼 on/off
      weight: null, // 사용자 몸무게

      // Step 1. 알쏭달쏭 단백질 퀴즈 문제 저장
      myproteinQuiz: {
        Q1: '',
        Q2: '',
        Q3: '',
        Q4: '',
        Q5: [],
        Q6: '',
        Q7: '',
        Q8: ''
      },

      // Step 2. 단백질 자가진단
      myproteinSelfCheck: {
        Q9: []
      },

      // Step 3. 단백질 섭취목적
      myproteinPurpose: {
        Q10: '',
        userWeight: ''
      },

      stepOneProgressBarWidth: '12.5%', // 1.알쏭달쏭 단백질 퀴즈
      stepTwoProgressBarWidth: '0%', // 2.단백질 부족 자가진단
      stepThrProgressBarWidth: '0%', // 3.하루 권장 섭취량 체크

      swiperOption: {
        allowTouchMove: false, // 마우스 슬라이드 미사용
        autoHeight: true,      // 높이 자동너비
        breakpoints: {
          1024: {
            width: 720
          }
        },
				centeredSlides: true,
        effect : 'coverflow',
        coverflowEffect: {
          depth: 100,
					modifier: 1,
					rotate: 50,
					slideShadows: true,
					stretch: 0
				},
        speed : 485,
        slideShadows: false,
        navigation: {
          nextEl: '.nextMove',
          prevEl: '.prev'
        }
      },
    }
  },
  mounted () {
    this.$el.style.backgroundColor = '#f7f7f7';
  },

  watch: {
    swiperIndex () {
      switch(this.swiperIndex) {
        case 6:
          window.scrollTo(0, 0);
          break
        case 10:
          window.scrollTo(0, 0);
          break

      }
      if(this.swiperIndex === 6) {
        window.scrollTo(0, 0);
      }
    }
  },
  methods: {
    // Swiper Slide Index 확인 및 답변 저장
    moveSwiperSlide (evnet) {
      const swiperContainer = document.querySelector('.swiper-container')

      if (swiperContainer) {
        // Find the swiper-wrapper element inside the swiper-container
        const swiperWrapper = swiperContainer.querySelector('.swiper-wrapper')

        if (swiperWrapper) {
          // You have found the swiper-wrapper element
          swiperWrapper.classList.add('animate')
        }
      }
      this.swiperIndex++
      this.$refs.mySwiper.$swiper.slideNext()
      this.updateProgressBar()
    },
    // Home 화면이동
    moveMainHome () {
      this.$router.push('/myprotein')
    },
    // Swiper 이전으로
    swiperSlidePrev() {

      let stepOneProgressBar = null
      let stepTwoProgressBar = null
      let stepThrProgressBar = null
      let newWidth = null

      if(this.swiperIndex > 1) {
        this.swiperIndex --
        if (this.swiperIndex < 8) {
          stepOneProgressBar = parseFloat(this.stepOneProgressBarWidth)
          newWidth = stepOneProgressBar - 12.5
          this.stepOneProgressBarWidth = `${newWidth}%`
        }else if (this.swiperIndex < 9) {
          stepTwoProgressBar = parseFloat(this.stepTwoProgressBarWidth)
          newWidth = stepTwoProgressBar - 100
          this.stepTwoProgressBarWidth = `${newWidth}%`
        }else {
          stepThrProgressBar = parseFloat(this.stepThrProgressBarWidth)
          newWidth = stepThrProgressBar - 50
          this.stepThrProgressBarWidth = `${newWidth}%`
        }
      }

      switch(this.swiperIndex) {
        case 1:
          this.myproteinQuiz.Q1 = ''
          break;
        case 2:
          this.myproteinQuiz.Q2 = ''
          break;
        case 3:
          this.myproteinQuiz.Q3 = ''
          break;
        case 4:
          this.myproteinQuiz.Q4 = ''
          this.myproteinQuiz.Q5 = []
          this.nextSwiperButton = false
          break;
        case 5:
          this.myproteinQuiz.Q5 = []
          break;
        case 6:
          this.myproteinQuiz.Q6 = ''
          break;
        case 7:
          this.myproteinQuiz.Q7 = ''
          break;
        case 8:
          this.myproteinQuiz.Q8 = ''
          this.myproteinSelfCheck.Q9 = []
          this.nextSwiperButton = false
          break;
        case 9:
          this.myproteinSelfCheck.Q9 = []
          break;
        case 10:
          this.myproteinPurpose.Q10 = ''
          break;
      }
    },

    // 5번문제 , Step2 스스로 알아보는 단백질 부족신호
    // 중복선택 시 버튼 on
    nextQuestion () {
      if(this.swiperIndex == 5 && this.myproteinQuiz.Q5.length <= 0) {
        this.nextSwiperButton = false
      }else if (this.swiperIndex == 9 && this.myproteinSelfCheck.Q9.length <= 0 ) {
        this.nextSwiperButton = false
      }else {
        this.nextSwiperButton = true
      }
    },
    // [다음] 버튼 클릭 후 off / 다음 슬라이드로 이동
    nextButtonClose () {
      this.nextSwiperButton = false
      this.swiperIndex++
      this.$refs.mySwiper.$swiper.slideNext()
      this.updateProgressBar()
    },

    // 답변저장
    async myproteinResult () {
      this.myproteinPurpose.userWeight = this.weight
      this.myproteinQuiz.Q5.sort()
      this.$store.commit(`${MYPROTEIN}/${SET_PROTEIN_QUIZ}`, this.myproteinQuiz)
      this.$store.commit(`${MYPROTEIN}/${SET_PROTEIN_SELF_CHECK}`, this.myproteinSelfCheck)
      this.$store.commit(`${MYPROTEIN}/${SET_PROTEIN_PURPOSE}`, this.myproteinPurpose)

      let data = {
        quiz: this.myproteinQuiz,
        self: this.myproteinSelfCheck,
        purp: this.myproteinPurpose,
        state : ''
      }
      localStorage.setItem('userAnswer', JSON.stringify(data))
      try {
        await axios.post(process.env.AWS_GATEWAY_URL_V2+'/myprotein-test/info/create',
        {
          quiz : this.myproteinQuiz,
          self : this.myproteinSelfCheck,
          purp : this.myproteinPurpose
        })
        .then(result => {
          if(result.data.status == 200)
            this.$router.push('/myprotein-calculate')
        })
      }catch(error) {
        console.log("Error > " , error)
      }
    },

    // 프로그래스바 증가
    updateProgressBar () {
      let stepOneProgressBar = null
      let stepTwoProgressBar = null
      let stepThrProgressBar = null
      let newWidth = null

      if (this.swiperIndex > 0) {
        // Step 1 . 알쏭달쏭 단백질 퀴즈 일경우
        if (this.swiperIndex <= 8) {
          stepOneProgressBar = parseFloat(this.stepOneProgressBarWidth)
          newWidth = stepOneProgressBar + 12.5
          this.stepOneProgressBarWidth = `${newWidth}%`
          // Step 2 . 스스로 알아보는 단백질 부족신호
        } else if (this.swiperIndex <= 9) {
          stepTwoProgressBar = parseFloat(this.stepTwoProgressBarWidth)
          newWidth = stepTwoProgressBar + 100
          this.stepTwoProgressBarWidth = `${newWidth}%`
        } else {
          // Step 3. 단백질 섭취목적 확인
          stepThrProgressBar = parseFloat(this.stepThrProgressBarWidth)
          newWidth = stepThrProgressBar + 50.0
          this.stepThrProgressBarWidth = `${newWidth}%`
        }
      }
    }

  }
}
</script>

<style scoped>
@import "./assets/css/amway.css";

* {
    font-family: "Noto Sans KR", -apple-system, BlinkMacSystemFont, system-ui, Roboto, "Helvetica Neue", "Segoe UI", "Apple SD Gothic Neo", "Malgun Gothic", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", sans-serif;
}

/*  Step 01 : CSS 적용하기 */
#weight {
  pointer-events: all !important;
}
#resultButton {
  pointer-events: all !important;
}
.first-index-prev-off {
  background : url("");
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/views/myprotein-test/myproteinQuiz.vue